import * as React from 'react'; // https://github.com/parcel-bundler/parcel/issues/1199
import * as ReactDOM from 'react-dom';

import { DatabaseId, ViewModel } from '../lib/types/types';
import { logger } from '../lib/utils/logger/logger';
import { assertValidHtmlElement, assertValidProgramId, assertValidTrackingId } from '../lib/types/assertions';

import { VerificationForm } from '../components/VerificationForm/VerificationFormComponent';

export class VerificationFormEs5 {
    element: HTMLElement;
    programId: DatabaseId;
    trackingId: string;
    viewModel: ViewModel;

    constructor(element: HTMLElement, programId: DatabaseId, trackingId?: string) {
        // In case the 'new' keyword isn't used by es5 devs
        if (!(this instanceof VerificationFormEs5)) {
            throw new Error('Method "render" not found. Did you use the "new" keyword when instantiating VerificationForm?');
        }

        logger.info(`Constructing VerificationFormEs5 ${programId}`);
        assertValidHtmlElement(element);
        assertValidProgramId(programId);
        this.element = element;
        this.programId = programId;
        this.trackingId = trackingId;

        this.render();
    }

    render() {
        ReactDOM.render(<VerificationForm programId={this.programId} trackingId={this.trackingId} />, this.element);
    }
}
